import {
  INotificationTableList,
  IMultiAssignData,
} from "../../../slices/NotificationSlice";
import { INotificationFeatures, ISSOUser } from "../../../slices/UserSlice";
import {
  LEVEL_CONSTANT,
  STATUS_CONSTANT,
} from "../modal/CreateAndEditNotify/FormDataConstants";

const NotificationCheckboxHandlerNew = (
  notificationTableList: INotificationTableList[],
  user: ISSOUser | null,
  multipleAssign: IMultiAssignData,
  notificationFeatures: INotificationFeatures
) => {
  //If the user is null, then set the visibility to false
  if (!user) {
    notificationTableList.map((notifyData) => {
      notifyData.rowSelection.visibility = false;
    });
    return;
  }

  if (multipleAssign.selectionType === "none") {
    notificationTableList.map((notifyData) => {
      notifyData.rowSelection.visibility = canAssignOrReassignNotificaion(
        notifyData,
        notificationFeatures
      );
    });
    return;
  } else if (multipleAssign.selectionType === "assigned") {
    notificationTableList.map((notifyData) => {
      notifyData.rowSelection.visibility = canAssignSecondNotification(
        notifyData,
        multipleAssign,
        notificationFeatures
      );
    });
  } else if (multipleAssign.selectionType === "reassign") {
    notificationTableList.map((notifyData) => {
      notifyData.rowSelection.visibility = canReassignSecondNotification(
        notifyData,
        multipleAssign,
        notificationFeatures
      );
    });
  }
};

const canAssignOrReassignNotificaion = (
  notification: INotificationTableList,
  notificationFeatures: INotificationFeatures
): boolean => {
  if (!notification) return false;

  //Assigned
  if (notification.assignedUser.length === 0) {
    //status should be waiting
    if (notification.status !== STATUS_CONSTANT.waiting) {
      return false;
    }

    //If the level is 1, then SSO admin only can assign
    if (
      notification.level === LEVEL_CONSTANT.level1 &&
      notificationFeatures.assignNotify.level1
    ) {
      return true;
    }
    //If the level is 2, then SSO Broadcast only can assign
    else if (
      notification.level === LEVEL_CONSTANT.level2 &&
      notificationFeatures.assignNotify.level2
    ) {
      return true;
    }

    return false;
  }
  //Reassign
  else if (notification.assignedUser.length > 0) {
    //status should be waiting or published
    if (
      notification.status !== STATUS_CONSTANT.waiting &&
      notification.status !== STATUS_CONSTANT.published
    ) {
      return false;
    }

    //If the level is 1, then SSO admin only can assign
    if (
      notification.level === LEVEL_CONSTANT.level1 &&
      notificationFeatures.assignNotify.level1
    ) {
      return true;
    }
    //If the level is 2, then SSO Broadcast only can assign
    else if (
      notification.level === LEVEL_CONSTANT.level2 &&
      notificationFeatures.assignNotify.level2
    ) {
      return true;
    }

    return false;
  }

  return false;
};

const canAssignSecondNotification = (
  notification: INotificationTableList,
  multipleAssign: IMultiAssignData,
  notificaionFeatures: INotificationFeatures
): boolean => {
  if (!notification) return false;

  //If the notification is not an assign type, then notification is not applicable for selection
  if (notification.assignedUser.length > 0) {
    return false;
  }

  if (notification.level !== multipleAssign.level) {
    return false;
  }

  //status should be waiting
  if (notification.status !== STATUS_CONSTANT.waiting) {
    return false;
  }

  //If the level is 1, then SSO admin only can assign
  if (
    notification.level === LEVEL_CONSTANT.level1 &&
    notificaionFeatures.assignNotify.level1
  ) {
    return true;
  }
  //If the level is 2, then SSO Broadcast only can assign
  else if (
    notification.level === LEVEL_CONSTANT.level2 &&
    notificaionFeatures.assignNotify.level2
  ) {
    return true;
  }

  return false;
};

const canReassignSecondNotification = (
  notification: INotificationTableList,
  multipleAssign: IMultiAssignData,
  notificaionFeatures: INotificationFeatures
): boolean => {
  if (!notification) return false;

  //If the notification is not an reassign, then its not applicable for selection
  if (notification.assignedUser.length <= 0) {
    return false;
  }

  if (notification.level !== multipleAssign.level) {
    return false;
  }

  if (notification.assignedUser[0] !== multipleAssign.assignedUser) {
    return false;
  }

  //status should be waiting or published
  if (
    notification.status !== STATUS_CONSTANT.waiting &&
    notification.status !== STATUS_CONSTANT.published
  ) {
    return false;
  }

  //If the level is 1, then SSO admin only can assign
  if (
    notification.level === LEVEL_CONSTANT.level1 &&
    notificaionFeatures.assignNotify.level1
  ) {
    return true;
  }
  //If the level is 2, then SSO Broadcast only can assign
  else if (
    notification.level === LEVEL_CONSTANT.level2 &&
    notificaionFeatures.assignNotify.level2
  ) {
    return true;
  }

  return false;
};

export default NotificationCheckboxHandlerNew;
